import { Eye, ScrollText } from 'lucide-react';
import { formatDate } from '@finmin/utils';
import { Button } from '@finmin/ui';
import type { ChannelPartnerAgreement } from '@/api/channel-partners';
import { openChannelPartnerDocument } from '../open-document';

/** The published General Agreement with a View action (opens the PDF). */
export function AgreementSummary({ agreement }: { agreement: ChannelPartnerAgreement }) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-border bg-card p-3">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-muted text-foreground">
        <ScrollText className="h-4 w-4" aria-hidden />
      </span>
      {/* basis-40 lets the button wrap below in a narrow column instead of squeezing the title. */}
      <div className="min-w-0 flex-1 basis-40">
        <p className="break-words text-sm font-medium text-foreground">{agreement.title}</p>
        <p className="text-xs text-muted-foreground">Published {formatDate(agreement.published_at)}</p>
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => void openChannelPartnerDocument(agreement.document_id)}
      >
        <Eye className="h-3.5 w-3.5" aria-hidden /> View agreement
      </Button>
    </div>
  );
}
